import { Link } from "react-router-dom";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import ContinueComponent from "../../toastAlerts/ContinueComponent";

//icons
import { PencilSquare } from "react-bootstrap-icons";
import { BsTrash } from "react-icons/bs";

const CountriesCard = ({
    item,
    id,
    handleDeleteCountries
}) => {
    const { t } = useTranslation();
    //show contnue
    const [showContinue, setShowContinue] = useState(false);

    return (
        <div className="bg-white rounded-xl p-5 w-full flex flex-col items-center justify-between gap-3 dark:bg-slate-700">
            <div className="w-full flex flex-col gap-2">
                <div className="flex gap-1 flex-wrap">
                    <p className="text-[12px] text-[#989ba5]">{t("admin_country")}:</p>
                    <p className="text-[#777a83] font-bold text-[14px] dark:text-gray-200">{item.name}</p>
                </div>
            </div>
            <div className="w-full flex gap-2">
                <Link to={`../countries/${id}`} className="w-full rounded-lg bg-violet-400
                 flex gap-2 items-center justify-center p-1 py-3">
                    <PencilSquare className="text-white font-bold" />
                    <p className="text-white text-sm font-bold">{t("admin_edit")}</p>
                </Link>
                <div
                    onClick={() => { setShowContinue(true) }}
                    className="w-12 rounded-lg bg-red-400 flex items-center justify-center cursor-pointer">
                    <BsTrash className="text-white" />
                </div>
            </div>
            <ContinueComponent
                showFlag={showContinue}
                actionFunction={handleDeleteCountries}
                setShowContinue={setShowContinue}
                id={id}
            />
        </div>
    )
}


export default CountriesCard;